/* eslint-disable @typescript-eslint/camelcase */
import {FunctionalComponent, h} from "preact";
import {useEffect} from "preact/hooks";
import {createScript} from "../../libs/ScriptHelper";
import {TYPES} from "../../libs/config";
import {MessageFrame} from "../../components/messageFrame";

declare const paypal: any;

export const PayBox: FunctionalComponent<{ msgID: string; payPalID: string; payButtonCfg: any; payCallback: (payRawObj: any) => void }> =
    ({
         msgID,
         payPalID,
         payButtonCfg,
         payCallback
     }) => {

        const params = payButtonCfg;
        const clientSecret = payPalID;
        const merchantId = params.merchantId;
        let jsURL = `https://www.paypal.com/sdk/js?client-id=${clientSecret}`;

        if (merchantId && merchantId !== 'querlo') {
            jsURL += `&merchant-id=${merchantId}`;
        }

        function castPayPalEvent(answerObj: any, ansID: number, cmdID: number): void {
            payCallback({
                b: {
                    o_ans: '',
                    json_data: answerObj,
                    ansID,
                    cmd_id: cmdID
                },
                t: TYPES.POLL_ANSWER
            });
        }

        useEffect(() => {
            createScript(jsURL).then(() => {
                paypal.Buttons({
                    style: {
                        layout: 'horizontal'
                    },
                    createOrder: function (data: any, actions: any) {
                        // This function sets up the details of the transaction, including the amount and line item details.
                        //TODO what's this? scope.$emit('EVT_UPDATE_VIEW');
                        return actions.order.create({
                            purchase_units: [{
                                amount: {
                                    value: params.price,
                                    currency: params.currency
                                }
                            }]
                        });
                    },
                    onCancel: function (data: any, actions: any): void {
                        // log.info(data, actions);
                        castPayPalEvent(data, 0, params.cmd_id);
                    },
                    onError: function (err: any): void {
                        // log.info(err);
                        castPayPalEvent(err, 0, params.cmd_id);
                    },
                    onApprove: function (data: any, actions: any) {
                        // This function captures the funds from the transaction.
                        return actions.order.capture()
                                      .then(function (details: any) {
                                          // log.info(details)
                                          // This function shows a transaction success message to your buyer.
                                          // alert('Transaction completed by ' + details.payer.name.given_name);
                                          castPayPalEvent(details, 1, params.cmd_id);
                                      });
                    }
                }).render(document.getElementById(msgID));
            });

        }, [msgID]);

        return <MessageFrame clsName='pay'>
          <div id={msgID} />
        </MessageFrame>;
    };
